var map = {
	"./alterac_pass.json": 49974,
	"./battlefield_of_eternity.json": 48653,
	"./blackhearts_bay.json": 85427,
	"./braxis_holdout.json": 95751,
	"./cursed_hollow.json": 58830,
	"./dragon_shire.json": 78245,
	"./garden_of_terror.json": 7304,
	"./hanamura_temple.json": 67537,
	"./infernal_shrines.json": 20802,
	"./sky_temple.json": 65989,
	"./tomb_of_the_spider_queen.json": 28881,
	"./towers_of_doom.json": 24436,
	"./volskaya_foundry.json": 29284,
	"./warhead_junction.json": 76959
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 26022;
module.exports = webpackAsyncContext;